import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		d: "M5.95 21.727l-3.675-3.675a.934.934 0 0 1 0-1.324l14.45-14.452a.933.933 0 0 1 1.325 0l3.675 3.675a.934.934 0 0 1 0 1.324L7.275 21.727a.94.94 0 0 1-1.325 0zm7.925-13.506l1.906 1.906 3.51-3.512-1.905-1.906-3.511 3.512zM7.427 3.537l-.457.93-1.024.148a.225.225 0 0 0-.124.383l.742.723-.176 1.02a.224.224 0 0 0 .324.238l.914-.485.914.48a.224.224 0 0 0 .324-.238l-.176-1.02.742-.722a.225.225 0 0 0-.125-.382l-1.023-.149-.457-.93c-.078-.16-.316-.16-.398.004zm3.815-.808l-.304.617-.684.102c-.12.02-.172.168-.082.253l.492.48-.117.68a.15.15 0 0 0 .219.157l.61-.32.608.32a.15.15 0 0 0 .22-.156l-.118-.68.492-.48a.148.148 0 0 0-.082-.254l-.683-.098-.305-.617a.145.145 0 0 0-.266-.004zm-7.498 0l-.305.617-.683.102c-.121.02-.172.168-.082.253l.492.48-.117.68a.15.15 0 0 0 .218.157l.61-.32.609.32a.15.15 0 0 0 .219-.156l-.118-.68.492-.48a.148.148 0 0 0-.082-.254l-.683-.098-.305-.617a.145.145 0 0 0-.265-.004zm16.247 8.73l-.305.617-.683.097c-.122.02-.172.168-.082.254l.492.48-.118.68a.15.15 0 0 0 .22.156l.608-.32.61.32a.15.15 0 0 0 .218-.156l-.117-.68.492-.48a.148.148 0 0 0-.082-.254l-.683-.097-.305-.617a.148.148 0 0 0-.265 0z",
		id: "aa"
	}) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-2 -2)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "bb",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#aa" })
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "currentColor",
				fillRule: "nonzero",
				xlinkHref: "#aa"
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#bb)",
				fill: "currentColor",
				children: /* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" })
			})
		]
	})]
});
export default SvgMagicIcon;
